<template>
  <div class="c-download-hang moblink-app" :style="styles" v-if="!isApp" v-touch:panend="handleTouchEnd" v-touch:panmove="handleTouchMove">
    <!-- <img class="c-download-hang-icon" src="@/assets/images/icon-cfmoto-fung@2x.png" alt="" /> -->
    <span class="c-download-hang-label">ZEEHO</span>
    <button type="button" class="c-download-hang-btn" @click="$emit('click')">{{ text }}</button>
    <div class="c-download-hang-safe-bottom" ref="bottom"></div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '在APP内打开',
    },
  },
  components: {},
  data() {
    return {
      startPageX: 0,
      startPageY: 0,
      X: 0,
      Y: 0,
      availWidth: document.documentElement.clientWidth,
      availHeight: document.documentElement.clientHeight,
      clientWidth: 0,
      clientHeight: 0,
      safeBottomHeight: 0,
    };
  },
  computed: {
    position() {
      const maxWidth = this.availWidth - this.clientWidth;
      const maxHeight = this.availHeight - this.clientHeight - this.safeBottomHeight;
      const X = this.startPageX + this.X;
      const Y = this.startPageY + this.Y;
      const left = X < 0 ? 0 : X > maxWidth ? maxWidth : X;
      const top = Y < 0 ? 0 : Y > maxHeight ? maxHeight : Y;
      return { left, top };
    },
    styles() {
      const left = this.position.left + 'px';
      const top = this.position.top + 'px';
      return { left, top };
    },
  },
  methods: {
    handleTouchEnd() {
      this.startPageX = this.startPageX + this.X;
      this.startPageY = this.startPageY + this.Y;
      this.X = 0;
      this.Y = 0;
      console.log('handleTouchEnd');
    },
    handleTouchMove(e) {
      this.X = e.X;
      this.Y = e.Y;
    },
  },
  created() {},
  mounted() {
    this.safeBottomHeight = this.$refs.bottom && this.$refs.bottom.offsetHeight;
    this.clientWidth = this.$el.clientWidth;
    this.clientHeight = this.$el.clientHeight;
    this.startPageX = this.availWidth / 2 - this.clientWidth / 2;
    this.startPageY = this.availHeight - this.clientHeight - this.safeBottomHeight - 54;
  },
  beforeUnmount() {},
  watch: {},
};
</script>
<style lang="scss">
.c-download-hang {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 999;
  // left: 0;
  // top: 0;
  left: calc(50% - 72px);
  top: calc(100vh - constant(safe-area-inset-bottom) - 54px);
  top: calc(100vh - env(safe-area-inset-bottom) - 54px);
  width: 212px;
  height: 40px;
  background: #000000;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  &-icon {
    margin-right: 5px;
    width: 53px;
    height: 20px;
  }
  &-label {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
  }
  &-btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 104px;
    height: 36px;
    border-radius: 18px;
    padding: 0 4px;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
  }
  &-safe-bottom {
    position: absolute;
    z-index: -99999;
    width: 1px;
    opacity: 0;
    height: constant(safe-area-inset-bottom);
    height: env(safe-area-inset-bottom);
  }
}
</style>
